import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChatApiService } from '../../services/chat-api.service';

export interface NewConversationDialogData {
  mode?: 'new' | 'add-participant';
  excludedProfilIds?: number[];
}

export type NewConversationResult =
  | { kind: 'direct'; profilId: number }
  | { kind: 'group'; name: string; profilIds: number[] }
  | { kind: 'add-participant'; profilId: number; showFullHistory: boolean };

interface ActiveProfil {
  id: number;
  imie: string;
  nazwisko: string;
}

/**
 * Jeden dialog dla trzech przypadkow (Patryk 28.09.2026 - "nazwe grupy wpisuje osoba
 * zakladajaca... z opcja dodania kogos pozniej"): nowa rozmowa 1:1, nowa grupa (nazwa
 * WYMAGANA), i dodanie osoby do istniejacej grupy (z checkboxem historii). Lista do wyboru
 * to zawsze tylko aktywni pracownicy (GET /profil domyslnie zwraca aktywnosc=1) - nieaktywni
 * nie pojawiaja sie w ogole, wiec nie da sie ich stad wybrac (blokada tez po stronie backendu).
 */
@Component({
  selector: 'app-new-conversation-dialog',
  templateUrl: './new-conversation-dialog.component.html',
  styleUrls: ['./new-conversation-dialog.component.sass'],
})
export class NewConversationDialogComponent implements OnInit {
  loading = true;
  profils: ActiveProfil[] = [];

  mode: 'direct' | 'group' = 'direct';
  selectedProfilId: number | null = null;
  groupName = '';
  selectedGroupProfilIds: number[] = [];
  showFullHistory = false;

  readonly isAddParticipant = this.data?.mode === 'add-participant';

  constructor(
    public dialogRef: MatDialogRef<NewConversationDialogComponent, NewConversationResult>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: NewConversationDialogData | null,
    private readonly api: ChatApiService,
  ) {}

  ngOnInit(): void {
    this.api.activeProfils().subscribe({
      next: (list) => {
        const excluded = new Set(this.data?.excludedProfilIds ?? []);
        this.profils = list.filter((p) => !excluded.has(p.id));
        this.loading = false;
      },
      error: () => { this.loading = false; },
    });
  }

  get canConfirm(): boolean {
    if (this.isAddParticipant) {
      return this.selectedProfilId != null;
    }

    if (this.mode === 'direct') {
      return this.selectedProfilId != null;
    }

    return this.groupName.trim().length > 0 && this.selectedGroupProfilIds.length > 0;
  }

  confirm(): void {
    if (!this.canConfirm) {
      return;
    }

    if (this.isAddParticipant) {
      this.dialogRef.close({ kind: 'add-participant', profilId: this.selectedProfilId!, showFullHistory: this.showFullHistory });
      return;
    }

    if (this.mode === 'direct') {
      this.dialogRef.close({ kind: 'direct', profilId: this.selectedProfilId! });
    } else {
      this.dialogRef.close({ kind: 'group', name: this.groupName.trim(), profilIds: this.selectedGroupProfilIds });
    }
  }
}
